import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
export default function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return ".".concat(classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.'));
}